// extracted by mini-css-extract-plugin
export default {"container":"fE-z","dimension":"gE-z","dimensionLabels":"hE-z"};